import { render, staticRenderFns } from "./RelatorioFornecedorView.vue?vue&type=template&id=86d52f94&scoped=true"
import script from "./RelatorioFornecedorView.vue?vue&type=script&lang=js"
export * from "./RelatorioFornecedorView.vue?vue&type=script&lang=js"
import style0 from "./RelatorioFornecedorView.vue?vue&type=style&index=0&id=86d52f94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d52f94",
  null
  
)

export default component.exports